import {
  Deal,
  Customer,
  Seller,
  Campaign,
  Activity,
  Conversation,
} from '../types'

export const sellers: Seller[] = [
  {
    id: '1',
    name: 'Ana Silva',
    avatar: 'https://i.pravatar.cc/150?u=1',
    role: 'vendedor',
    salesCount: 145,
    revenue: 125000,
    whatsappConnected: true,
    rankingChange: 2,
  },
  {
    id: '2',
    name: 'Carlos Mendes',
    avatar: 'https://i.pravatar.cc/150?u=2',
    role: 'vendedor',
    salesCount: 132,
    revenue: 98000,
    whatsappConnected: true,
    rankingChange: -1,
  },
  {
    id: '3',
    name: 'Juliana Costa',
    avatar: 'https://i.pravatar.cc/150?u=3',
    role: 'gerente',
    salesCount: 128,
    revenue: 115000,
    whatsappConnected: true,
    rankingChange: 0,
  },
  {
    id: '4',
    name: 'Pedro Santos',
    avatar: 'https://i.pravatar.cc/150?u=4',
    role: 'vendedor',
    salesCount: 98,
    revenue: 75000,
    whatsappConnected: false,
    rankingChange: 1,
  },
  {
    id: '5',
    name: 'Mariana Oliveira',
    avatar: 'https://i.pravatar.cc/150?u=5',
    role: 'vendedor',
    salesCount: 85,
    revenue: 62000,
    whatsappConnected: true,
    rankingChange: -2,
  },
  {
    id: '6',
    name: 'Lucas Ferreira',
    avatar: 'https://i.pravatar.cc/150?u=6',
    role: 'vendedor',
    salesCount: 82,
    revenue: 58000,
    whatsappConnected: true,
    rankingChange: 3,
  },
  {
    id: '7',
    name: 'Beatriz Alves',
    avatar: 'https://i.pravatar.cc/150?u=7',
    role: 'vendedor',
    salesCount: 78,
    revenue: 54000,
    whatsappConnected: true,
    rankingChange: 1,
  },
  {
    id: '8',
    name: 'Rafael Lima',
    avatar: 'https://i.pravatar.cc/150?u=8',
    role: 'vendedor',
    salesCount: 71,
    revenue: 49000,
    whatsappConnected: false,
    rankingChange: -1,
  },
  {
    id: '9',
    name: 'Camila Rocha',
    avatar: 'https://i.pravatar.cc/150?u=9',
    role: 'vendedor',
    salesCount: 65,
    revenue: 45000,
    whatsappConnected: true,
    rankingChange: 0,
  },
  {
    id: '10',
    name: 'Fernando Souza',
    avatar: 'https://i.pravatar.cc/150?u=10',
    role: 'vendedor',
    salesCount: 58,
    revenue: 41000,
    whatsappConnected: true,
    rankingChange: 2,
  },
  {
    id: '11',
    name: 'Patricia Martins',
    avatar: 'https://i.pravatar.cc/150?u=11',
    role: 'vendedor',
    salesCount: 52,
    revenue: 38000,
    whatsappConnected: true,
    rankingChange: -3,
  },
  {
    id: '12',
    name: 'Roberto Costa',
    avatar: 'https://i.pravatar.cc/150?u=12',
    role: 'vendedor',
    salesCount: 45,
    revenue: 32000,
    whatsappConnected: false,
    rankingChange: -1,
  },
]

export const deals: Deal[] = [
  {
    id: '1',
    storeName: 'Beleza Pura',
    contactName: 'Fernanda',
    responsibleSeller: sellers[0],
    estimatedValue: 5000,
    stage: 'novo',
    lastContact: '2023-10-25T10:00:00',
    whatsapp: '5511999999999',
  },
  {
    id: '2',
    storeName: 'Diva Makeup',
    contactName: 'Patricia',
    responsibleSeller: sellers[1],
    estimatedValue: 12000,
    stage: 'negociacao',
    lastContact: '2023-10-24T14:30:00',
    whatsapp: '5511999999999',
  },
  {
    id: '3',
    storeName: 'Glamour & Cia',
    contactName: 'Roberto',
    responsibleSeller: sellers[0],
    estimatedValue: 8500,
    stage: 'proposta',
    lastContact: '2023-10-23T09:15:00',
    whatsapp: '5511999999999',
  },
  {
    id: '4',
    storeName: 'Espaço da Beleza',
    contactName: 'Camila',
    responsibleSeller: sellers[2],
    estimatedValue: 3200,
    stage: 'pagamento',
    lastContact: '2023-10-25T11:00:00',
    whatsapp: '5511999999999',
  },
  {
    id: '5',
    storeName: 'Makeup Pro',
    contactName: 'Lucas',
    responsibleSeller: sellers[3],
    estimatedValue: 15000,
    stage: 'fechado',
    lastContact: '2023-10-20T16:45:00',
    whatsapp: '5511999999999',
  },
  {
    id: '6',
    storeName: 'Cosméticos Chic',
    contactName: 'Amanda',
    responsibleSeller: sellers[4],
    estimatedValue: 4500,
    stage: 'perdido',
    lastContact: '2023-10-18T13:20:00',
    whatsapp: '5511999999999',
  },
  {
    id: '7',
    storeName: 'Loja da Ju',
    contactName: 'Juliana',
    responsibleSeller: sellers[1],
    estimatedValue: 2500,
    stage: 'novo',
    lastContact: '2023-10-26T09:00:00',
    whatsapp: '5511999999999',
  },
]

export const customers: Customer[] = [
  {
    id: '1',
    storeName: 'Beleza Pura',
    contactName: 'Fernanda',
    phone: '(11) 99999-9999',
    email: 'contato@belezapura.com',
    lastPurchase: '2023-10-15',
    purchaseFrequency: 'Alta',
    totalSpent: 45000,
    status: 'Ativo',
    city: 'São Paulo',
    tags: ['VIP', 'Atacadista'],
  },
  {
    id: '2',
    storeName: 'Diva Makeup',
    contactName: 'Patricia',
    phone: '(21) 98888-8888',
    email: 'patricia@divamakeup.com',
    lastPurchase: '2023-09-20',
    purchaseFrequency: 'Média',
    totalSpent: 12500,
    status: 'Morno',
    city: 'Rio de Janeiro',
    tags: ['Revenda'],
  },
  {
    id: '3',
    storeName: 'Glamour & Cia',
    contactName: 'Roberto',
    phone: '(31) 97777-7777',
    email: 'roberto@glamour.com',
    lastPurchase: '2023-08-10',
    purchaseFrequency: 'Baixa',
    totalSpent: 5000,
    status: 'Frio',
    city: 'Belo Horizonte',
    tags: ['Novo'],
  },
  {
    id: '4',
    storeName: 'Espaço da Beleza',
    contactName: 'Camila',
    phone: '(41) 96666-6666',
    email: 'camila@espaco.com',
    lastPurchase: '2023-10-22',
    purchaseFrequency: 'Alta',
    totalSpent: 82000,
    status: 'Ativo',
    city: 'Curitiba',
    tags: ['VIP', 'Franquia'],
  },
  {
    id: '5',
    storeName: 'Makeup Pro',
    contactName: 'Lucas',
    phone: '(51) 95555-5555',
    email: 'lucas@makeuppro.com',
    lastPurchase: '2023-10-05',
    purchaseFrequency: 'Média',
    totalSpent: 28000,
    status: 'Ativo',
    city: 'Porto Alegre',
    tags: [],
  },
]

export const campaigns: Campaign[] = [
  {
    id: '1',
    name: 'Black Friday Antecipada',
    targetAudience: 'Clientes VIP',
    status: 'Agendada',
    recipientsCount: 150,
    metrics: { sent: 0, delivered: 0, responded: 0 },
  },
  {
    id: '2',
    name: 'Reativação 30 dias',
    targetAudience: 'Inativos > 30d',
    status: 'Enviada',
    sentDate: '2023-10-20',
    recipientsCount: 45,
    metrics: { sent: 45, delivered: 42, responded: 8 },
  },
  {
    id: '3',
    name: 'Lançamento Linha Gold',
    targetAudience: 'Todos',
    status: 'Rascunho',
    recipientsCount: 320,
  },
]

export const activities: Activity[] = [
  {
    id: '1',
    type: 'sale',
    description: 'fechou venda com Makeup Pro',
    timestamp: '2023-10-26T10:30:00',
    user: sellers[3],
    value: 15000,
  },
  {
    id: '2',
    type: 'lead',
    description: 'cadastrou novo lead Loja da Ju',
    timestamp: '2023-10-26T09:00:00',
    user: sellers[1],
  },
  {
    id: '3',
    type: 'campaign',
    description: 'enviou campanha Reativação',
    timestamp: '2023-10-25T15:00:00',
    user: sellers[2],
  },
  {
    id: '4',
    type: 'contact',
    description: 'agendou reunião com Diva Makeup',
    timestamp: '2023-10-25T14:00:00',
    user: sellers[1],
  },
]

export const conversations: Conversation[] = [
  {
    id: '1',
    contactName: 'Fernanda',
    storeName: 'Beleza Pura',
    avatar: 'https://i.pravatar.cc/150?u=10',
    lastMessage: 'Pode me enviar o catálogo atualizado?',
    timestamp: '2023-10-26T10:45:00',
    unreadCount: 2,
    connectedNumber: '+55 11 99999-9999',
    messages: [
      {
        id: '1',
        text: 'Bom dia, Fernanda! Tudo bem?',
        sender: 'me',
        timestamp: '2023-10-26T10:40:00',
        status: 'read',
      },
      {
        id: '2',
        text: 'Bom dia! Tudo ótimo.',
        sender: 'them',
        timestamp: '2023-10-26T10:42:00',
        status: 'read',
      },
      {
        id: '3',
        text: 'Pode me enviar o catálogo atualizado?',
        sender: 'them',
        timestamp: '2023-10-26T10:45:00',
        status: 'read',
      },
    ],
  },
  {
    id: '2',
    contactName: 'Patricia',
    storeName: 'Diva Makeup',
    avatar: 'https://i.pravatar.cc/150?u=11',
    lastMessage: 'Vou verificar o estoque e te aviso.',
    timestamp: '2023-10-26T09:30:00',
    unreadCount: 0,
    connectedNumber: '+55 11 99999-9999',
    messages: [
      {
        id: '1',
        text: 'Oi Patricia, conseguiu ver a proposta?',
        sender: 'me',
        timestamp: '2023-10-26T09:00:00',
        status: 'read',
      },
      {
        id: '2',
        text: 'Vou verificar o estoque e te aviso.',
        sender: 'them',
        timestamp: '2023-10-26T09:30:00',
        status: 'read',
      },
    ],
  },
]
